<div class="chat" [class.chat_max]="hideChatInMobile">
  <div class="chat__column_main">
    <chat-header
      [hide]="hideChatInMobile"
      class="chat__header"
      [chat]="chat"
      [permissions]="permissions"
      [(visibleDetails)]="visibleDetails"
      (delete)="onDeleteChat()"
      (leave)="onLeaveChat()"
      (muteChange)="onMuteChange($event)"
    ></chat-header>

    <div class="chat__body" [hide]="hideChatInMobile">
      <tui-scrollbar class="scrollbar" (scroll)="onScroll()">
        <messages-list
          *ngIf="chat && chat.chatId"
          [chatId]="chat.chatId"
          [messages]="messages"
          [permissions]="permissions"
          [lastReadMessageId]="chat.lastReadMessageId"
          [firstIncomingUnreadMessageId]="firstIncomingUnreadMessageId"
          [allMessagesOnScreen]="allMessagesOnScreen"
        ></messages-list>
      </tui-scrollbar>

      <button
        tuiIconButton
        type="button"
        class="button-scroll-bottom"
        [class.visible]="scrollToBottomButtonVisible"
        [style.border-radius.%]="100"
        [appearance]="'primary'"
        [size]="'m'"
        [iconStart]="'@tui.arrow-down'"
        (click)="scrollToBottom()"
      ></button>
    </div>

    <div class="chat__footer" [hide]="hideChatInMobile">
      <chat-footer
        *ngIf="chat && chat.chatId"
        [chatId]="chat.chatId"
        [permissions]="permissions"
        (textMessageSent)="scrollToBottom()"
      ></chat-footer>
    </div>
  </div>

  <div class="chat__column_right">
    <chat-details
      *ngIf="visibleDetails"
      class="chat__details"
      [chat]="chat"
      [permissions]="permissions"
      (close)="visibleDetails = false"
    ></chat-details>
  </div>
</div>
